module.exports = __webpack_public_path__ + "static/media/Fun88_Affiliate_logo_CN.88d129da.webp";